export default __webpack_public_path__ + "static/calendar-6d746309a9248f14ff939c7d3407baba.jpg";